<script src="../plugins/globals.js"></script>
<template>
  <basic-page title="Ilmoitustaulu">
    <v-row class="fill-height">
      <v-col cols="12" lg="8" offset-lg="2" offset-xl="2" xl="8">
        <v-row class="mb-5">
          <v-col v-if="$isAdmin" cols="12">
            <alarm-map />
          </v-col>
          <v-col v-if="$isNaisosasto" cols="12">
            <muonitus-info />
          </v-col>

          <v-col v-if="kalustonhuoltoInfo" cols="12">
            <v-card
              :color="kalustonhuoltoInfo.isCurrentWeek ? 'warning' : 'info'"
              dark
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Kalustonhuolto</div>
                  <v-list-item-subtitle
                    class="text-h6 mb-1 white--text text-wrap"
                  >
                    {{ kalustonhuoltoInfo.message }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap white--text">
                    Ryhmä {{ kalustonhuoltoInfo.groupNumber }}, viikko
                    {{ kalustonhuoltoInfo.week }} ({{
                      kalustonhuoltoInfo.startDate
                    }}
                    - {{ kalustonhuoltoInfo.endDate }})
                    <br />
                    Huollettavat yksiköt: {{ kalustonhuoltoInfo.engines }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon large>mdi mdi-wrench</v-icon>
                </v-list-item-avatar>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="white"
                  @click="
                    $router.push({
                      path: '/kalusto',
                      query: { tab: 'viikkohuolto' },
                    })
                  "
                >
                  Siirry kalustonhuoltoon
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col v-if="nextHarjoitus" cols="12" md="6">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Harjoitukset</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextHarjoitus.subject }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(nextHarjoitus.date)
                      }}
                      {{ formatType(nextHarjoitus.type) }},
                      {{ nextHarjoitus.location }},
                      {{ nextHarjoitus.info }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-fireplace</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col v-if="nextEvyHarjoitus" cols="12" md="6">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Evy</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextEvyHarjoitus.subject }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(nextEvyHarjoitus.date)
                      }}
                      {{ formatType(nextEvyHarjoitus.type) }},
                      {{ nextEvyHarjoitus.location }},
                      {{ nextEvyHarjoitus.info }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-hospital-box</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col v-if="nextTukiosastonHarjoitus" cols="12" md="6">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Tukiosaston harjoitukset</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextTukiosastonHarjoitus.subject }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(
                          nextTukiosastonHarjoitus.date,
                        )
                      }}
                      {{ formatType(nextTukiosastonHarjoitus.type) }},
                      {{ nextTukiosastonHarjoitus.location }},
                      {{ nextTukiosastonHarjoitus.info }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-account-group-outline</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col
            v-if="nextHallitusKokous && nextHallitusKokous.dateStart"
            cols="12"
            md="6"
          >
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Hallituksen kokous</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextHallitusKokous.title }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(
                          nextHallitusKokous.dateStart +
                            " " +
                            (nextHallitusKokous.timeStart || "00:00"),
                        )
                      }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-gavel</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col v-if="myTasks.length > 0" cols="12" md="6">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Omat tehtävät</div>
                </v-list-item-content>
              </v-list-item>
              <v-list dense>
                <v-list-item
                  v-for="task in myTasks"
                  :key="task.id"
                  @click="
                    $router.push({
                      path: '/tehtavat',
                      query: { tehtava: task.id },
                    })
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ task.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <span v-if="task.ilmoitus">
                        {{ task.ilmoitus.orderNumber }}
                        {{ task.ilmoitus.title }}
                      </span>
                      <span v-if="task.ilmoitus && task.deadline"> - </span>
                      <span>{{ $formatDate(task.deadline) }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>

          <v-col v-if="latestFiles.length > 0" cols="12" md="6">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Uusimmat tiedostot</div>
                </v-list-item-content>
              </v-list-item>
              <v-list dense>
                <v-list-item
                  v-for="file in latestFiles"
                  :key="file.id"
                  @click="$router.push({ name: 'Tiedostopankki' })"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ file.filename }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      $formatDateAndHourMinute(file.createdAt)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>

        <v-card
          v-if="kiinteistopaivystysInfo"
          :color="kiinteistopaivystysInfo.isCurrentWeek ? 'warning' : 'info'"
          class="mb-5"
          dark
        >
          <v-list-item>
            <v-list-item-content>
              <div class="text-overline mb-4">
                Leirikosken kiinteistöpäivystys
              </div>
              <v-list-item-subtitle class="text-h6 mb-1 white--text text-wrap">
                {{ kiinteistopaivystysInfo.message }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-wrap white--text">
                Viikko {{ kiinteistopaivystysInfo.week }} ({{
                  kiinteistopaivystysInfo.startDate
                }}
                - {{ kiinteistopaivystysInfo.endDate }})
                <br />
                Päävuorossa: {{ kiinteistopaivystysInfo.primary }}
                <span v-if="kiinteistopaivystysInfo.secondary">
                  , varalla: {{ kiinteistopaivystysInfo.secondary }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-icon large>mdi mdi-home-group</v-icon>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="white"
              @click="
                $router.push({
                  path: '/leirikoski',
                  query: { tab: 'vihko' },
                })
              "
            >
              Siirry Leirikoskelle
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <leirikoski-vihko-info v-if="$isVihkoSeuranta" class="mb-5" />

        <v-card>
          <v-card-text>
            <span class="subtitle-1"
              >Tänään on viikko {{ week }}, {{ today }}</span
            >
          </v-card-text>
          <v-divider />

          <v-card-text>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-btn
                      class="mr-4"
                      color="grey darken-2"
                      outlined
                      @click="setToday"
                    >
                      Tänään
                    </v-btn>
                    <v-btn color="grey darken-2" fab small text @click="prev">
                      <v-icon small> mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn color="grey darken-2" fab small text @click="next">
                      <v-icon small> mdi-chevron-right</v-icon>
                    </v-btn>
                    <responsive-toolbar-title v-if="$refs.calendar">
                      {{ $formatMonthYear($refs.calendar.value || Date.now()) }}
                    </responsive-toolbar-title>
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          color="grey darken-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <span>{{ typeToLabel[calendarType] }}</span>
                          <v-icon right> mdi-menu-down </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="calendarType = 'day'">
                          <v-list-item-title>Päivä</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="calendarType = 'week'">
                          <v-list-item-title>Viikko</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="calendarType = 'month'">
                          <v-list-item-title>Kuukausi</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :events="filteredEvents"
                    :weekdays="weekdays"
                    color="primary"
                    :type="calendarType"
                    @click:event="showEvent"
                  ></v-calendar>
                  <v-menu
                    v-model="selectedOpen"
                    :activator="selectedElement"
                    :close-on-content-click="false"
                    offset-x
                  >
                    <v-card color="grey lighten-4" flat min-width="250px">
                      <v-toolbar :color="selectedEvent.color" dark>
                        <span>{{ selectedEvent.name }} </span>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-text>
                        <div v-if="selectedEvent.dateStart">
                          <span class="text-subtitle-2">
                            {{
                              $capitalFirstLetter(
                                $formatWeekDay(
                                  selectedEvent.dateStart +
                                    " " +
                                    (selectedEvent.timeStart || "00:00:00"),
                                ),
                              )
                            }}
                            {{
                              $formatDateAndHourMinute(
                                selectedEvent.dateStart +
                                  " " +
                                  (selectedEvent.timeStart || "00:00:00"),
                              )
                            }}</span
                          >

                          <span
                            v-if="selectedEvent.dateEnd"
                            class="text-subtitle-2"
                          >
                            -
                            {{
                              $capitalFirstLetter(
                                $formatWeekDay(
                                  selectedEvent.dateEnd +
                                    " " +
                                    (selectedEvent.timeEnd || "00:00:00"),
                                ),
                              )
                            }}
                            {{
                              $formatDateAndHourMinute(
                                selectedEvent.dateEnd +
                                  " " +
                                  (selectedEvent.timeEnd || "00:00:00"),
                              )
                            }}</span
                          >
                        </div>
                      </v-card-text>
                      <v-card-text>
                        <span v-html="selectedEvent.details"></span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          color="secondary"
                          text
                          @click="selectedOpen = false"
                        >
                          Sulje
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title class="mt-5"
            >Ilmoitustaulu
            <v-spacer />
            <div class="d-flex align-center">
              <v-btn
                v-if="isNotificationsSupported"
                :color="notificationPermission === 'granted' ? 'success' : 'warning'"
                :outlined="notificationPermission === 'granted'"
                rounded
                small
                class="mr-2"
                :loading="loadingNotificationPermission"
                @click="requestNotifications"
              >
                <v-icon left small>
                  {{
                    notificationPermission === "granted"
                      ? "mdi-bell-check"
                      : "mdi-bell-ring"
                  }}
                </v-icon>
                {{
                  notificationPermission === "granted"
                    ? "Ilmoitukset päällä"
                    : "Ota ilmoitukset käyttöön"
                }}
              </v-btn>
              <div v-if="$isAdmin || $isNaisosasto">
                <v-btn color="primary" rounded @click="createIlmoitus" small>
                  <v-icon>mdi mdi-plus</v-icon> Uusi ilmoitus
                </v-btn>
              </div>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-subtitle>
            <!-- Buttons for filtering filteredIlmoitukset type property kokous, ilmoitus, ilmoittautuminen -->
            <v-row no-gutters justify="start" align-content="center">
              <v-icon class="mr-2">mdi mdi-filter</v-icon>
              <v-btn-toggle v-model="eventFilter" multiple>
                <v-btn value="ilmoitus" small>
                  <template v-if="$vuetify.breakpoint.mdAndUp"
                    >Ilmoitukset</template
                  >
                  <template v-else>
                    <v-icon>mdi mdi-exclamation-thick</v-icon>
                  </template>
                </v-btn>
                <v-btn value="ilmoittautuminen" small>
                  <template v-if="$vuetify.breakpoint.mdAndUp"
                    >Ilmoittautumiset</template
                  >
                  <template v-else>
                    <v-icon>mdi mdi-account-multiple</v-icon>
                  </template>
                </v-btn>
              </v-btn-toggle>

              <v-spacer />
              <v-switch
                v-model="showOld"
                class="ml-5 mt-n1"
                dense
                hide-details
                inset
                prepend-icon="mdi mdi-eye"
                title="Näytä vanhat ilmoitukset"
              >
              </v-switch>
            </v-row>
          </v-card-subtitle>
          <v-divider />
          <v-card-text v-if="loading">
            <v-skeleton-loader
              type="list-item-three-line,list-item-three-line,list-item-three-line,list-item-three-line,list-item-three-line"
              width="100%"
            />
          </v-card-text>
        </v-card>

        <template v-if="!loading">
          <template v-for="ilmoitus in filteredIlmoitukset">
            <ilmoitus-list-item
              :key="ilmoitus.id"
              :ilmoitus="ilmoitus"
              @reload="reloadIlmoitukset"
            />
            <!--<v-divider :key="`${i}_2`" class="mb-4 mt-2" />-->
          </template>
        </template>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import ResponsiveToolbarTitle from "@/components/ResponsiveToolbarTitle.vue";
import dayjs from "dayjs";
import Ilmoittautuminen from "@/components/Ilmoitustaulu/Ilmoittautuminen";
import IlmoitusListItem from "@/components/Ilmoitustaulu/IlmoitusListItem";
import MuonitusInfo from "@/components/Ilmoitustaulu/MuonitusInfo";
import LeirikoskiVihkoInfo from "@/components/Ilmoitustaulu/LeirikoskiVihkoInfo";
import api from "@/api";

import { orderBy } from "lodash";
import {
  computeWeeksAndGroups,
  KALUSTOHUOLTO_GROUPS,
} from "../../functions/kalustohuoltoSchedule";
import { TALONHENKILOT } from "../../functions/leirikoskiTalonhenkilot";
import {
  collection,
  getDocs,
  query,
  orderBy as fsOrderBy,
} from "firebase/firestore";
import { firestore as db } from "@/plugins/firebase.app";
import app, { getToken } from "@/plugins/firebase.app";
import { getMessaging } from "firebase/messaging";

export default {
  name: "Ilmoitustaulu",
  components: {
    Ilmoittautuminen,
    BasicPage,
    IlmoitusListItem,
    AlarmMap: () =>
      import(
        /* webpackChunkName: "view-alarm-map" */ "@/components/Ilmoitustaulu/AlarmMap"
      ),
    MuonitusInfo,
    LeirikoskiVihkoInfo,
    ResponsiveToolbarTitle,
  },
  data() {
    return {
      ilmoitukset: [],
      hallitusIlmoitukset: [],
      tukiosastonharjoitukset: [],
      latestFiles: [],
      myTasks: [],
      loading: false,
      focus: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      permissionMessages: [],
      eventFilter: [],
      showOld: false,
      typeToLabel: {
        month: "Kuukausi",
        week: "Viikko",
        day: "Päivä",
      },
      isNotificationsSupported: "Notification" in window,
      notificationPermission:
        "Notification" in window ? Notification.permission : "default",
      loadingNotificationPermission: false,
      calendarType: "month",
    };
  },
  computed: {
    filteredIlmoitukset() {
      // eslint-disable-next-line no-undef
      let ilmoitukset = structuredClone(this.ilmoitukset);
      ilmoitukset.forEach((i) => {
        i._date = [i.dateStart, i.timeEnd, i.createdAt, i.created]
          .filter(Boolean)
          .join(" ");
      });
      if (this.eventFilter.length > 0) {
        ilmoitukset = ilmoitukset.filter((ilmoitus) =>
          this.eventFilter.includes(ilmoitus.type),
        );
      }
      return orderBy(ilmoitukset, ["_date"], ["asc"]);
    },
    filteredEvents() {
      // eslint-disable-next-line no-undef
      let ilmoitukset = structuredClone(this.ilmoitukset);
      ilmoitukset.forEach((i) => {
        i._date = [i.dateStart, i.timeEnd, i.createdAt, i.created]
          .filter(Boolean)
          .join(" ");
      });
      let hallitusIlmoitukset = structuredClone(this.hallitusIlmoitukset);
      hallitusIlmoitukset.forEach((i) => {
        i._date = [i.dateStart, i.timeEnd, i.createdAt, i.created]
          .filter(Boolean)
          .join(" ");
      });
      return [
        ilmoitukset
          ?.filter((e) => e.dateStart && dayjs(e.dateStart).isValid())
          .map((e) => {
            const startStr = e.dateStart + " " + (e.timeStart || "00:00:00");
            const hasEnd = e.dateEnd && dayjs(e.dateEnd).isValid();
            const endStr =
              (hasEnd ? e.dateEnd : e.dateStart) +
              " " +
              (e.timeEnd || "00:00:00");
            const startDate = dayjs(startStr);
            const endDate = dayjs(endStr);
            return {
              ...e,
              name: e.title,
              start: startDate.isValid() ? startDate.toDate() : null,
              end: endDate.isValid() ? endDate.toDate() : null,
              timed: true,
              details: e.content,
              type: "hallitus",
            };
          })
          .filter((e) => e.start && e.end) || [],
        hallitusIlmoitukset
          ?.filter((e) => e.dateStart && dayjs(e.dateStart).isValid())
          .map((e) => {
            const startStr = e.dateStart + " " + (e.timeStart || "00:00:00");
            const hasEnd = e.dateEnd && dayjs(e.dateEnd).isValid();
            const endStr =
              (hasEnd ? e.dateEnd : e.dateStart) +
              " " +
              (e.timeEnd || "00:00:00");
            const startDate = dayjs(startStr);
            const endDate = dayjs(endStr);
            return {
              ...e,
              name: "Hallitus: " + e.title,
              start: startDate.isValid() ? startDate.toDate() : null,
              end: endDate.isValid() ? endDate.toDate() : null,
              timed: true,
              details: `Hallituksen ${e.type}`,
              type: "hallitusIlmoitus",
              color: "grey",
            };
          })
          .filter((e) => e.start && e.end) || [],
        this.harjoitukset.map((e) => {
          return {
            ...e,
            name: e.subject,
            start: dayjs(e.date).toDate(),
            timed: true,
            type: "harjoitus",
            color: "info",
            details: [
              `<strong>${this.$formatDateAndHourMinute(e.date)}</strong>`,
              `Aihe: <strong>${e.subject}</strong>`,
              `Paikka: <strong>${e.location}</strong>`,
              `Tyyppi: <strong>${e.type}</strong>`,
              `Kouluttaja: <strong>${e.info}</strong>`,
            ].join("</br> "),
          };
        }) || [],
        this.evyharjoitukset.map((e) => {
          return {
            ...e,
            name: e.subject,
            start: dayjs(e.date).toDate(),
            timed: true,
            type: "evy",
            color: "error",
            details: [
              `<strong>${this.$formatDateAndHourMinute(e.date)}</strong>`,
              `Aihe: <strong>${e.subject}</strong>`,
              `Paikka: <strong>${e.location}</strong>`,
              `Tyyppi: <strong>${e.type}</strong>`,
              `Kouluttaja: <strong>${e.info}</strong>`,
            ].join("</br> "),
          };
        }) || [],
        this.tukiosastonharjoitukset.map((e) => {
          return {
            ...e,
            name: e.subject,
            start: dayjs(e.date).toDate(),
            timed: true,
            type: "tukiosastonharjoitus",
            color: "purple",
            details: [
              `<strong>${this.$formatDateAndHourMinute(e.date)}</strong>`,
              `Aihe: <strong>${e.subject}</strong>`,
              `Paikka: <strong>${e.location}</strong>`,
              `Tyyppi: <strong>${e.type}</strong>`,
              `Kouluttaja: <strong>${e.info}</strong>`,
            ].join("</br> "),
          };
        }) || [],
      ].flatMap((e) => e);
    },
    today() {
      return dayjs().format("LLLL");
    },
    week() {
      return dayjs().format("w");
    },
    harjoitukset() {
      if (this.$isOnlyNaisosasto) return [];
      return this.$store.state.harjoitukset;
    },
    evyharjoitukset() {
      if (this.$isOnlyNaisosasto) return [];
      return this.$store.state.evyharjoitukset;
    },
    nextHarjoitus() {
      const today = dayjs();
      const nextHarjoitus = this.harjoitukset.find(
        (h) => h && dayjs(h.date).isAfter(today),
      );
      return nextHarjoitus;
    },
    nextEvyHarjoitus() {
      const today = dayjs();
      const nextEvyHarjoitus = this.evyharjoitukset.find(
        (h) => h && dayjs(h.date).isAfter(today),
      );
      return nextEvyHarjoitus;
    },
    nextTukiosastonHarjoitus() {
      if (!this.$isNaisosasto) return null;
      const today = dayjs();
      return this.tukiosastonharjoitukset.find(
        (h) => h && dayjs(h.date).isAfter(today),
      );
    },
    nextHallitusKokous() {
      if (!this.$isHallitus) return null;
      const today = dayjs();
      const meetings = this.hallitusIlmoitukset
        .filter((i) => i.type === "kokous" && i.dateStart)
        .filter((i) => {
          const date = i.dateStart + " " + (i.timeStart || "00:00:00");
          return dayjs(date).isAfter(today);
        });
      return orderBy(meetings, ["dateStart", "timeStart"], ["asc"])[0];
    },
    kalustonhuoltoInfo() {
      // Skip if user is only naisosasto (doesn't participate in maintenance)
      if (this.$isOnlyNaisosasto) return null;

      // Get user's name from the logged in user info
      const userName = this.$userInfo?.displayName;

      if (!userName) return null;

      // Debug logging (can be removed in production)
      console.log("Checking kalustonhuolto for user:", userName);

      const groups = KALUSTOHUOLTO_GROUPS;

      // Find which group the user belongs to
      // Use flexible name matching to handle different name formats
      const userGroup = groups.find((group) =>
        group.people.some((person) => {
          const personName = person.name.toLowerCase();
          const userNameLower = userName.toLowerCase();

          // Direct match
          if (personName === userNameLower) return true;

          // Check if all words in either name are present in the other
          const personWords = personName
            .split(" ")
            .filter((word) => word.length > 1);
          const userWords = userNameLower
            .split(" ")
            .filter((word) => word.length > 1);

          // Check if person's words are all in user's name (handles "Heikkilä Kai" vs "Kai Heikkilä")
          const personWordsInUser = personWords.every((word) =>
            userNameLower.includes(word),
          );
          const userWordsInPerson = userWords.every((word) =>
            personName.includes(word),
          );

          return (
            personWordsInUser && userWordsInPerson && personWords.length >= 2
          );
        }),
      );

      if (!userGroup) {
        console.log("User not found in any kalustonhuolto group");
        return null;
      }

      console.log("User found in group:", userGroup.number, userGroup.name);

      // Calculate weeks and groups using shared module
      const weeksData = computeWeeksAndGroups({ weeksAhead: 3 });
      const currentWeek = dayjs().format("WW/GGGG");
      const nextWeek = dayjs().add(1, "week").format("WW/GGGG");

      for (const wg of weeksData) {
        if (
          (wg.week === currentWeek || wg.week === nextWeek) &&
          wg.group === userGroup.number
        ) {
          const isCurrentWeek = wg.week === currentWeek;
          const message = isCurrentWeek
            ? "Sinulla on kalustonhuoltoviikko tällä viikolla!"
            : "Sinulla on kalustonhuoltoviikko ensi viikolla!";

          return {
            message,
            week: wg.week,
            groupNumber: wg.group,
            startDate: wg.startDate,
            endDate: wg.endDate,
            engines: wg.engine,
            isCurrentWeek,
          };
        }
      }

      return null;
    },
    kiinteistopaivystysInfo() {
      const userName = this.$userInfo?.displayName;
      if (!userName) return null;

      const weeks = [
        { key: dayjs().format("W/GGGG"), offset: 0, isCurrentWeek: true },
        {
          key: dayjs().add(1, "week").format("W/GGGG"),
          offset: 1,
          isCurrentWeek: false,
        },
      ];

      for (const week of weeks) {
        const row = TALONHENKILOT.find((h) => h[0] === week.key);
        if (!row) continue;

        const isPrimary = this.nameMatchesUser(row[1], userName);
        const isSecondary = this.nameMatchesUser(row[2], userName);
        if (!isPrimary && !isSecondary) continue;

        const start = dayjs().add(week.offset, "week").startOf("isoWeek");
        const when = week.isCurrentWeek ? "tällä viikolla" : "ensi viikolla";
        return {
          message: isPrimary
            ? `Sinulla on Leirikosken kiinteistöpäivystysvuoro ${when}!`
            : `Olet Leirikosken kiinteistöpäivystyksen varahenkilö ${when}.`,
          week: week.key,
          primary: row[1],
          secondary: row[2],
          startDate: start.format("DD.MM.YYYY"),
          endDate: start.add(6, "day").format("DD.MM.YYYY"),
          isCurrentWeek: week.isCurrentWeek,
        };
      }

      return null;
    },
  },
  watch: {
    showOld() {
      this.reloadIlmoitukset();
    },
  },
  methods: {
    // Schedules list names as "Sukunimi Etunimi", displayName is usually the other way around.
    nameMatchesUser(personName, userName) {
      if (!personName || !userName) return false;
      const person = personName.toLowerCase();
      const user = userName.toLowerCase();
      if (person === user) return true;

      const personWords = person.split(" ").filter((w) => w.length > 1);
      const userWords = user.split(" ").filter((w) => w.length > 1);
      return (
        personWords.length >= 2 &&
        personWords.every((w) => user.includes(w)) &&
        userWords.every((w) => person.includes(w))
      );
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true)),
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    setToday() {
      this.focus = "";
    },

    async reloadHarjoitukset() {
      this.$store.dispatch("loadHarjoitukset");
    },
    async reloadTukiosastonHarjoitukset() {
      if (!this.$isNaisosasto) return;
      try {
        const snap = await getDocs(
          query(
            collection(db, "tukiosastonharjoitukset"),
            fsOrderBy("date", "asc"),
          ),
        );
        this.tukiosastonharjoitukset = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
      } catch (e) {
        console.error(e);
      }
    },
    async reloadIlmoitukset() {
      if (this.ilmoitukset.length === 0) {
        this.loading = true;
      }
      try {
        const ilmoitukset = (
          await api.ilmoituksetList({ showAll: this.showOld })
        ).data;

        ilmoitukset.forEach((ilmoitus) => {
          if (
            ilmoitus.participants?.findIndex(
              (il) => il.sub === this.$user.uid,
            ) > -1
          ) {
            ilmoitus._participant = true;
          }
        });
        this.ilmoitukset = ilmoitukset;
      } catch (e) {
        console.error(e);
        this.$toast("Ilmoitusten haku epäonnistui.", {
          type: "error",
        });
      }
      this.loading = false;
    },
    async reloadHallitusIlmoitukset() {
      try {
        let ilmoitukset;
        if (this.$isHallitus) {
          ilmoitukset = (await api.ilmoituksetHallitusList()).data;
        } else {
          ilmoitukset = (await api.ilmoituksetHallitusListPublished()).data;
        }
        this.hallitusIlmoitukset = ilmoitukset;
      } catch (e) {
        console.error(e);
        this.$toast("Hallituksen ilmoitusten haku epäonnistui.", {
          type: "error",
        });
      }
    },
    async fetchLatestFiles() {
      try {
        const result = (await api.tiedostopankkiGetFilesAndCategories()).data;
        const files = result.files.filter((file) => {
          if (file.departments) {
            return (
              this.$isAdmin ||
              (this.$isUser && file.departments.includes("halytysosasto")) ||
              (this.$isNaisosasto && file.departments.includes("naisosasto"))
            );
          }
          return true;
        });
        this.latestFiles = orderBy(files, "createdAt", "desc").slice(0, 3);
      } catch (e) {
        console.error(e);
      }
    },
    async fetchMyTasks() {
      try {
        const tasks = (
          await api.tehtavaHallitusList({
            type: "tehtava",
            yearStart: 2024,
          })
        )?.data;

        this.myTasks = tasks.filter(
          (t) =>
            t.assignedTo?.some((a) => a.sub === this.$user.uid) &&
            t.status !== "READY",
        );
      } catch (e) {
        console.error(e);
      }
    },
    reloadAll() {
      this.reloadHarjoitukset();
      this.reloadTukiosastonHarjoitukset();
      this.reloadIlmoitukset();
      this.reloadHallitusIlmoitukset();
      this.fetchLatestFiles();
      this.fetchMyTasks();
    },
    formatType(type) {
      return type === "OT" ? "Oppitunti" : type === "HT" ? "Harjoitus" : "";
    },
    createIlmoitus() {
      this.$router.push({ name: "Ilmoitus" });
    },
    async requestNotifications() {
      if (!("Notification" in window)) {
        this.$toast("Selaimesi ei tue push-ilmoituksia.", { type: "info" });
        return;
      }
      this.loadingNotificationPermission = true;
      try {
        localStorage.removeItem("notificationPermissionDenied");
        const permission = await Notification.requestPermission();
        this.notificationPermission = permission;

        if (permission !== "granted") {
          this.$toast("Ilmoituslupaa ei myönnetty.", { type: "warning" });
          return;
        }

        const messaging = getMessaging(app);
        const serviceWorkerRegistration = await navigator.serviceWorker.ready;
        const token = await getToken(messaging, {
          vapidKey:
            "BCZ3S_HG6b-bUNUJkxygFPTu_UDHfthcEcFmCODFxCTVNNVNRbZtRhYWcNnK7DMkTWAfLEopWOynqpOb_pcJyi0",
          serviceWorkerRegistration,
        });

        if (token) {
          console.log("[Ilmoitustaulu] Acquired messaging token:", token);
          await api.firebaseMessagingAddToken({
            token,
            userAgent: navigator.userAgent,
          });
          this.$toast("Ilmoitukset otettu käyttöön onnistuneesti!", {
            type: "success",
          });
        } else {
          this.$toast("Tokenin haku epäonnistui.", { type: "error" });
        }
      } catch (e) {
        console.error("[Ilmoitustaulu] requestNotifications error:", e);
        this.$toast("Virhe ilmoitusten käyttöönotossa.", { type: "error" });
      } finally {
        this.loadingNotificationPermission = false;
        if ("Notification" in window) {
          this.notificationPermission = Notification.permission;
        }
      }
    },
  },
  mounted() {
    if ("Notification" in window) {
      this.notificationPermission = Notification.permission;
    }
    this.reloadAll();
  },
};
</script>

<style lang="scss" scoped>
.align-self-start {
  align-self: flex-start;
}
</style>
